import { render, staticRenderFns } from "./cardItemByTrain.vue?vue&type=template&id=a94ea1c2&"
import script from "./cardItemByTrain.vue?vue&type=script&lang=js&"
export * from "./cardItemByTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardItemByTrain.vue"
export default component.exports